export const joannaKrzyzanowska = {
    'meta': {
        'title': 'Psycholog, pedagog, psychoterapeuta Joanna Krzyżanowska',
        'description': 'Jestem dyplomowanym psychologiem i pedagogiem, a także psychoterapeutą w trakcie szkolenia. Pracuję z osobami dorosłymi oraz młodzieżą od 12 roku życia.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-pedagog-psychoterapeuta-joanna-krzyzanowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/joanna-krzyzanowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, pedagog, psychoterapeuta w Bydgoszczy Joanna Krzyżanowska'
        }
    }
}